module.exports = __webpack_public_path__ + "static/pemalex_logo_clientes_dilady-0b214920deb497c0b8158e25f7f7428a.png";